import { enrich } from '@procuros/transformer';
import { DocumentType } from 'support/types';
import { logError } from 'services/logging/logging';

export const enrichDocument = <T>({ data, messageType }: { data: T; messageType?: DocumentType }): { data: T } => {
  if (!messageType) {
    return { data };
  }

  const enrichmentResult = enrich({
    input: data,
    documentType: messageType,
  });

  if (!enrichmentResult.success) {
    logError(`Enrichment failed: ${enrichmentResult.error_message}`);
    return { data };
  }

  return { data: enrichmentResult.result };
};
